var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"accent",attrs:{"fixed":"","app":""}},[_c('v-app-bar-nav-icon',{staticClass:"hidden-lg-and-up",on:{"click":_vm.toggle}}),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.settings.name)+" Admin")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.logout}}),_c('v-icon',[_vm._v("mdi-logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }